var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconPlusCircle = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 15,
  height: 14
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#222",
  fillRule: "evenodd",
  d: "M7.422 0a7 7 0 1 1 0 14 7 7 0 0 1 0-14m0 1.4a5.6 5.6 0 1 0 0 11.2 5.6 5.6 0 0 0 0-11.2m0 2.1c.387 0 .7.319.7.697V6.3h2.103c.353 0 .645.261.69.604l.007.096c0 .387-.319.7-.697.7l-2.104-.001.001 2.104a.696.696 0 0 1-.604.69l-.096.007a.703.703 0 0 1-.7-.697V7.7H4.62a.697.697 0 0 1-.697-.7c0-.387.32-.7.697-.7h2.103V4.197c0-.353.261-.645.605-.69l.095-.007z"
})));
export default SvgIconPlusCircle;